import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/api/client';

export function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: true,
        retry: (count, error) => {
          // Don't retry client errors (401 is handled by the API client's refresh).
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
          return count < 2;
        },
      },
    },
  });
}
